<div class="notification-bar" [ngClass]="{'notification-success': type === 'success', 'notification-error': type === 'error', 'notification-warning': type === 'warning'}">
    {{ message }}
  </div>
